import { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Loader2, MailCheck } from "lucide-react";
import { API, formatApiErrorDetail } from "../context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email });
      setSent(true);
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 px-4">
      <div className="w-full max-w-md" data-testid="forgot-password-page">
        <div className="mb-8 text-center">
          <img src="/logo.png" alt="Forum Erkelenz MyTraining Logo" className="mx-auto mb-4 h-16 w-16 object-contain" data-testid="forgot-password-logo" />
          <h1 className="font-heading text-3xl font-bold tracking-tight text-zinc-100">
            Passwort vergessen
          </h1>
          <p className="mt-2 text-sm text-zinc-400">
            Wir senden dir einen Link zum Zurücksetzen.
          </p>
        </div>
        <div className="rounded-xl border border-zinc-800 bg-zinc-900 p-6 shadow-sm sm:p-8">
          {sent ? (
            <div className="flex flex-col items-center gap-3 py-4 text-center" data-testid="forgot-password-success">
              <MailCheck className="h-10 w-10 text-primary" />
              <p className="text-sm text-zinc-400">
                Wenn diese E-Mail registriert ist, haben wir dir einen Link zum
                Zurücksetzen gesendet. Der Link ist 1 Stunde gültig.
              </p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4" data-testid="forgot-password-form">
              <div className="space-y-2">
                <Label htmlFor="fp-email">E-Mail</Label>
                <Input
                  id="fp-email"
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="name@beispiel.de"
                  data-testid="forgot-password-email-input"
                />
              </div>
              {error && (
                <p className="rounded-lg bg-red-950/50 px-3 py-2 text-sm text-destructive" data-testid="forgot-password-error">
                  {error}
                </p>
              )}
              <Button
                type="submit"
                className="w-full bg-primary hover:bg-primary/90"
                disabled={loading}
                data-testid="forgot-password-submit-button"
              >
                {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
                Link senden
              </Button>
            </form>
          )}
        </div>
        <p className="mt-6 text-center text-sm text-zinc-400">
          <Link to="/login" className="font-semibold text-primary hover:underline" data-testid="back-to-login-link">
            Zurück zur Anmeldung
          </Link>
        </p>
      </div>
    </div>
  );
}
